import debug from "debug";

import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/customise-product';
const log = debug(MODULE_NAME);

const FORM_ELEMENT_SELECTOR = 'form.add-to-quote-form';
const ELEMENT_SELECTOR = '[data-customise-product]';

const FORM_ADD_TYPE = 'data-add-to-quote-add-type';
const ICONS = {
    cartIcon: "icon--cart",
    quoteIcon: "icon--quote",
};

const QUOTE_LABEL_ATTR = 'data-add-to-quote-label';
const CART_LABEL_ATTR = 'data-add-to-cart-label';
const QUOTE_ADD_TYPE = 'data-quote-add-type';
const ADD_TYPE = 'data-add-to-quote-add-type';
const CART_ADD_TYPE = 'data-cart-add-type';
const ICON_ELEMENT_SELECTOR = '[data-button-icon-element]';
const LABEL_ELEMENT_SELECTOR = '[data-button-label-element]';



class CustomiseProduct {

    constructor(element, options) {
        this.options = options;

        // there are two form elements, almost identical
        this.$elements = $(FORM_ELEMENT_SELECTOR);
        this.$custom = this.$elements.find('[name="customise"]');

        this.self = this;

        this.quoteLabel = this.$elements.attr(QUOTE_LABEL_ATTR);
        this.cartLabel = this.$elements.attr(CART_LABEL_ATTR);
        this.addType = this.$elements.attr(ADD_TYPE);
        this.quoteAddType = this.$elements.attr(QUOTE_ADD_TYPE);
        this.cartAddType = this.$elements.attr(CART_ADD_TYPE);

        this.$optionPanel = $(this.options.optionPanel);
        this.$custom = this.$elements.find('[name="customise"]');
        this.$customSelectDisplay = $(this.options.customSelectDisplay);

        this.initialAddType = this.$elements.attr('data-add-to-quote-add-type');

        $(document).on('customise', this.customiseChanged.bind(this));
        $(document).on('added-to-cart', this.addedToCart.bind(this));
    }

    customiseChanged(event) {
        // customise toggle changed
        var label, icon, addType;
        if (this.addType == 'quote' || this.$custom.is(':checked')) {
            // add to quote only
            label = this.quoteLabel;
            icon = ICONS.quoteIcon;
            addType = this.quoteAddType;
        } else if (this.addType == 'cart') {
            // add to cart only
            label = this.cartLabel;
            icon = ICONS.cartIcon;
            addType = this.cartAddType;
        }
        var self = this.self;
        for(var i = 0; i < self.$elements.length; i++) {
            self.updateForm(self.$elements.eq(i), label, icon, addType);
        }
    }

    addedToCart() {
        // items added to cart / quote
        if (this.$custom.length > 0) {
            this.$custom.removeAttr('checked');
            this.$customSelectDisplay.removeAttr('disabled');
        }
        if (this.$optionPanel.length > 0) {
            this.$optionPanel.removeClass('is-customised');
        }
        this.resetForm();
    }

    updateForm($formElement, label, icon, addType) {
        var $labelElement = $formElement.find(LABEL_ELEMENT_SELECTOR);
        var $iconElement = $formElement.find(ICON_ELEMENT_SELECTOR);

        $labelElement.text(label);

        this.removeIconClasses($iconElement);
        $iconElement.addClass(icon);

        $formElement.attr(FORM_ADD_TYPE, addType);
    }

    removeIconClasses($iconElement) {
        Object.keys(ICONS).forEach((k) => { $iconElement.removeClass(ICONS[k] ); });
    }

    resetForm() {
        var self = this.self;

        if (this.initialAddType === 'cart') {
            var label = this.cartLabel;
            var icon = ICONS.cartIcon;
            var addType = this.cartAddType;
        } else if (this.initialAddType === 'quote') {
            var label = this.quoteLabel;
            var icon = ICONS.quoteIcon;
            var addType = this.quoteAddType;
        }

        for(var i = 0; i < self.$elements.length; i++) {
            self.updateForm(self.$elements.eq(i), label, icon, addType);
        }
    }
}

CustomiseProduct.DEFAULTS = {
    optionPanel: '#option_panel',
    customSelectDisplay: '.custom-select__display',
};

plugin('customiseProduct', CustomiseProduct);

export function exec() {
    $(document).ready(() => {
        $(ELEMENT_SELECTOR).customiseProduct();
    });
}





// WEBPACK FOOTER //
// ./client/src/core/modules/customise-product/index.js